<template>
  <v-row class="mb-3">
    <v-col cols="12" class="d-block d-sm-flex justify-space-between">
      <p class="mb-2 mb-sm-0 body-2 mr-sm-4" style="max-width: 400px;">
        {{ $t("message.visibility.summary.map.legend.info") }}
      </p>
      <div class="d-flex align-center mb-2 mb-sm-0" style="min-width:320px;">
        <span class="body-2 text-no-wrap">1</span>
        <div class="scale"></div>
        <span class="body-2 text-no-wrap">{{ maxPosition }} </span>
      </div>
      <div class="d-flex align-center mb-2 mb-sm-0">
        <div class="dot"></div>
        <span class="body-2">{{
          $t("message.common.positionAbove", [maxPosition])
        }}</span>
      </div>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "MapLegend",
  data() {
    return {
      maxPosition: 20
    };
  }
};
</script>

<style lang="scss" scoped>
.scale {
  max-width: 228px;
  width: 100%;
  height: 5px;
  background: linear-gradient(90deg, #1bcb11 0%, #fdaa10 49.12%, #fb1c2c 100%);
  border-radius: 7px;
  margin: 0 $spacing * 1.25;
}

.dot {
  margin: 0 $spacing * 1.25;
  height: 10px;
  width: 10px;
  min-width: 10px;
  background: $gray-light;
  border-radius: 11px;
}
</style>
